import React from "react";

export const Team = (props) => {
  return (
    <div id="team" className="text-center">
      <div className="container">
        <div className="col-md-8 col-md-offset-2 section-title">
          <h2>Meet the Team</h2>
          <p>
            Our team is composed of dedicated professionals who are passionate about what they do.
          </p>
        </div>
        
        <div id="row">
          {/* BARIS PERTAMA: 3 Orang di Atas (Di-center pakai trik inline-block aman) */}
          <div className="row">
            {props.data
              ? props.data.slice(0, 3).map((d, i) => (
                  <div 
                    key={`${d.name}-${i}`} 
                    className="col-md-3 col-sm-6 team"
                    /* KUNCI DI SINI: Mematikan float bawaan Bootstrap dan menjadikannya inline-block */
                    style={{ float: "none", display: "inline-block", verticalAlign: "top" }}
                  >
                    <div className="thumbnail">
                      <img src={d.img} alt="..." className="team-img" />
                      <div className="caption">
                        <h4>{d.name}</h4>
                        <p>{d.job}</p>
                      </div>
                    </div>
                  </div>
                ))
              : "loading"}
          </div>

          {/* BARIS KEDUA: 4 Orang di Bawah (Otomatis penuh 12 grid bawaan Bootstrap) */}
          <div className="row">
            {props.data
              ? props.data.slice(3, 7).map((d, i) => (
                  <div key={`${d.name}-${i}`} className="col-md-3 col-sm-6 team">
                    <div className="thumbnail">
                      <img src={d.img} alt="..." className="team-img" />
                      <div className="caption">
                        <h4>{d.name}</h4>
                        <p>{d.job}</p>
                      </div>
                    </div>
                  </div>
                ))
              : "loading"}
          </div>
        </div>
        
      </div>
    </div>
  );
};